import {CategoryMsWindowProductType} from '../categoryItemsType';
import {PRODUCT_TYPES} from 'constants/product';

/**
 * Prepare fetched category data
 * @param {Omit<CategoryMsWindowProductType, 'isContactLenses'>[]} items - category response
 * @returns {CategoryMsWindowProductType[]} - prepared data for category
 */
export const categoryItemsAdapter = (
    items: Omit<CategoryMsWindowProductType, 'isContactLenses'>[],
): CategoryMsWindowProductType[] =>
    items.map(item => ({
        ...item,
        isContactLenses: item?.children[0]?.type === PRODUCT_TYPES.CONTACT_LENSES,
        children: item?.children.map(child => ({
            ...child,
            isContactLenses: child.type === PRODUCT_TYPES.CONTACT_LENSES,
        })),
    }));
